import React, { useState, useEffect } from "react";
import { Col, Container, Row, Alert, Modal } from "react-bootstrap";
import { TextInputForm, DropDownUI, Calender } from "../../components/Forms";
import { ClickButton } from "../../components/ClickButton";
import PageNav from "../../components/PageNav";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_DOMAIN from "../../config/config";

const UserCreation = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const today = new Date();
  const [searchText, setSearchText] = useState("");
  const [userData, setUserData] = useState([]);
  const defaultDate = today.toISOString().substr(0, 10);

  const initialState =
    type === "edit"
      ? {
        ...rowData,
        interest_receive_date: rowData.interest_receive_date,
        outstanding_period: rowData.outstanding_period || "",
        outstanding_amount: rowData.outstanding_amount || "",
      }
      : {
        receipt_no: "",
        interest_receive_date: new Date().toISOString().substr(0, 10),
        customer_details: "",
        place: "",
        mobile_number: "",
        original_amount: "",
        interest_rate: "",
        pledged_items: "",
        item: "",
        total_weight: "",
        item_location: "",
        interest_income: "",
        outstanding_period: "",
        outstanding_amount: "",
        topup_amount: "",
        deduction_amount: "",
        status: "",
      };
  const [formData, setFormData] = useState(initialState);
  console.log("formData", formData);

  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();

  const redirectModal = () => {
    navigate("/console/interest");
  };

  const handleSearchChange = (e, searchType) => {
    const value = e.target.value;
    setSearchText(value);

    const matchedData = userData.find((item) => {
      if (searchType === "receipt_no")
        return item.receipt_no.toString() === value;
      if (searchType === "mobile_number")
        return item.mobile_number.toString() === value;
      if (searchType === "customer_details")
        return item.name === value;
      return false;
    });
    console.log(matchedData, "matchedData");

    if (matchedData) {
      setFormData({
        ...formData,
        receipt_no: matchedData.receipt_no || "",
        customer_details: matchedData.name || "",
        place: matchedData.place || "",
        mobile_number: matchedData.mobile_number || "",
        original_amount: matchedData.original_amount || "",
        interest_rate: matchedData.interest_rate || "",
        pledged_items: matchedData.pledged_items || "",
        item: matchedData.item || "",
        total_weight: matchedData.total_weight || "",
        item_location: matchedData.item_location || "",
        outstanding_period: matchedData.interest_payment_period || "",
        outstanding_amount: matchedData.interest_payment_amount || "",
        status: matchedData.status || "",
      });
    } else {
      setFormData({
        ...formData,
        [searchType]: value,
        customer_details: searchType === "customer_details" ? value : "",
        place: searchType === "place" ? value : "",
        mobile_number: searchType === "mobile_number" ? value : "",
        receipt_no: searchType === "receipt_no" ? value : "",
        original_amount: "",
        interest_rate: "",
        pledged_items: "",
        item: "",
        total_weight: "",
        item_location: "",
        outstanding_period: "",
        outstanding_amount: "",
        status: "",
      });
    }
  };

  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;

    let updatedFormData = { ...formData };

    if (rowIndex !== undefined) {
      // If rowIndex is defined, it means we are updating a table row
      updatedFormData = {
        ...formData,
      };
    } else {
      // If rowIndex is undefined, update the top-level formData
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };
    }

    setFormData({
      ...updatedFormData,
      [fieldName]: value,
    });
  };

  const setLabel = (date, label) => {
    let dateString =
      date instanceof Date ? date.toISOString().substr(0, 10) : date;

    if (!dateString || isNaN(new Date(dateString))) {
      console.error("Invalid date:", date);
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [label]: dateString,
    }));
  };

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: searchText,
        }),
      });

      const responseData = await response.json();
      console.log("responseData", responseData);
      setLoading(false);
      if (responseData.head.code === 200) {
        setLoading(false);
        setLoading(false);
        setUserData(responseData.body.pawnjewelry);
        console.log(setUserData);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, [searchText]);

  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    setLoading(true);
    setLoading(true);
    try {
      const interestIncome = parseFloat(formData.interest_income) || 0;
      const outstandingAmount = parseFloat(formData.outstanding_amount) || 0;
      const topupAmount = parseFloat(formData.topup_amount) || 0;
      const deductionAmount = parseFloat(formData.deduction_amount) || 0;

      console.log({
        interestIncome,
        outstandingAmount,
        topupAmount,
        deductionAmount,
      });
      const isTopupOnly = topupAmount > 0 && deductionAmount <= 0;
      const isDeductionOnly = deductionAmount > 0 && topupAmount <= 0;
      const isBothEmptyOrZero = topupAmount <= 0 && deductionAmount <= 0;

      if (!isTopupOnly && !isDeductionOnly && !isBothEmptyOrZero) {
        toast.error(
          "Please enter either Top-up or Deduction amount, not both.",
          {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          }
        );
        setLoading(false);
        setLoading(false);
        setLoading(false);
        return;
      }

      if (topupAmount > 0 || deductionAmount > 0) {
        if (interestIncome != outstandingAmount) {
          toast.error(
            "Please pay all outstanding interest before adding a top-up.",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
            }
          );
          setLoading(false);
          setLoading(false);
          setLoading(false);
          return;
        }
      }

      const response = await fetch(`${API_DOMAIN}/interest.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, edit_interest_id: "" }),
      });

      const responseData = await response.json();

      console.log(responseData);

      if (responseData.head.code === 200) {
        setLoading(false);
        setLoading(false);
        toast.success(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/interest");
        }, 1000);
      } else {
        setLoading(false);
        toast.error(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        setLoading(false);
        setShowAlert(true);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);

      setLoading(false);
    }
  };

  const handleUpdateSubmit = async (e) => {
    setLoading(true);
    setLoading(true);

    try {
      const response = await fetch(`${API_DOMAIN}/interest.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          edit_interest_id: rowData.interest_id,
          receipt_no: formData.receipt_no,
          interest_receive_date: formData.interest_receive_date,
          customer_details: formData.customer_details,
          place: formData.place,
          mobile_number: formData.mobile_number,
          original_amount: formData.original_amount,
          interest_rate: formData.interest_rate,
          pledged_items: formData.pledged_items,
          item: formData.item,
          total_weight: formData.total_weight,
          item_location: formData.item_location,
          interest_income: formData.interest_income ?? 0,
          outstanding_period: formData.outstanding_period,
          outstanding_amount: formData.outstanding_amount,
          topup_amount: formData.topup_amount,
          deduction_amount: formData.deduction_amount,
        }),
      });

      const responseData = await response.json();
      console.log(
        JSON.stringify({
          edit_interest_id: rowData.interest_id,
          receipt_no: formData.receipt_no,
          interest_receive_date: formData.interest_receive_date,
          customer_details: formData.customer_details,
          place: formData.place,
          mobile_number: formData.mobile_number,
          original_amount: formData.original_amount,
          interest_rate: formData.interest_rate,
          pledged_items: formData.pledged_items,
          item: formData.item,
          total_weight: formData.total_weight,
          item_location: formData.item_location,
          interest_income: formData.interest_income,
          outstanding_period: formData.outstanding_period,
          outstanding_amount: formData.outstanding_amount,
          topup_amount: formData.topup_amount,
          deduction_amount: formData.deduction_amount,
        })
      );

      if (responseData.head.code === 200) {
        setLoading(false);
        setLoading(false);
        toast.success(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        setTimeout(() => {
          navigate("/console/interest");
        }, 2000);
      } else {
        setLoading(false);
        toast.error(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        console.error(
          responseData.message || "Unknown error occurred during update"
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error updating product:", error.message);

      setLoading(false);
    }

    setLoading(false);
  };

  return (
    <div>
      <Container>
        <Row className="regular">
          <Col lg="12" md="12" xs="12" className="py-3 d-flex align-items-center">
            <PageNav
              pagetitle={`வட்டி ${type === "view"
                ? " வியூ "
                : type === "edit"
                  ? "  எடிட் "
                  : "உருவாக்கம்"
                }`}
            ></PageNav>
            {formData.status && (
              <span
                style={{
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontWeight: "600",
                  fontSize: "12px",
                  backgroundColor:
                    formData.status === "Closed" ? "#28a745" : "#dc3545",
                  color: "white",
                  marginLeft: "15px",
                }}
              >
                {formData.status === "Closed"
                  ? "நகை மீட்கபட்டது"
                  : "நகை மீட்கபடவில்லை"}
              </span>
            )}
          </Col>

          <Col lg="3" md="6" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அடகு எண்"}
              labelname={"அடகு எண்"}
              name="receipt_no"
              value={formData.receipt_no}
              onChange={(e) => handleSearchChange(e, "receipt_no")}
            />
          </Col>
          <Col lg="3" md="6" xs="12" className="py-3">
            <Calender
              setLabel={(date) => setLabel(date, "interest_receive_date")}
              initialDate={
                type === "edit" ? formData.interest_receive_date : undefined
              }
              calenderlabel="தேதி"
              disabled={type === "view" || type === "edit"}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"பெயர்"}
              labelname={"பெயர்"}
              name="customer_details"
              value={formData.customer_details}
              onChange={(e) => handleSearchChange(e, "customer_details")}
            />
          </Col>

          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"இடம்"}
              labelname={"இடம்"}
              name="place"
              value={formData.place}
              onChange={(e) => handleChange(e, "place")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"மொபைல் எண்"}
              labelname={"மொபைல் எண்"}
              name="mobile_number"
              value={formData.mobile_number}
              onChange={(e) => handleSearchChange(e, "mobile_number")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அசல் தொகை"}
              labelname={"அசல் தொகை"}
              name="original_amount"
              value={formData.original_amount}
              onChange={(e) => handleChange(e, "original_amount")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"வட்டி விகிதம்"}
              labelname={"வட்டி விகிதம்"}
              name="interest_rate"
              value={formData.interest_rate}
              onChange={(e) => handleChange(e, "interest_rate")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அடகு பொருட்கள்"}
              labelname={"அடகு பொருட்கள்"}
              name="pledged_items"
              value={formData.pledged_items}
              onChange={(e) => handleChange(e, "pledged_items")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"உருப்படி"}
              labelname={"உருப்படி"}
              name="item"
              value={formData.item}
              onChange={(e) => handleChange(e, "item")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"மொத்த எடை"}
              labelname={"மொத்த எடை"}
              name="total_weight"
              value={formData.total_weight}
              onChange={(e) => handleChange(e, "total_weight")}
            ></TextInputForm>
          </Col>
          {/* <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"பொருளின் இடம்"}
              labelname={"பொருளின் இடம்"}
              name="item_location"
              value={formData.item_location}
              onChange={(e) => handleChange(e, "item_location")}
            ></TextInputForm>
          </Col> */}

          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"நிலுவை காலம்"}
              labelname={"நிலுவை காலம்"}
              name="outstanding_period"
              value={formData.outstanding_period}
              onChange={(e) => handleChange(e, "outstanding_period")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"நிலுவை தொகை"}
              labelname={"நிலுவை தொகை"}
              name="outstanding_amount"
              value={formData.outstanding_amount}
              onChange={(e) => handleChange(e, "outstanding_amount")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"வட்டி வரவு"}
              labelname={"வட்டி வரவு"}
              name="interest_income"
              value={formData.interest_income}
              onChange={(e) => handleChange(e, "interest_income")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அசல் தொகை கூட்டுதல்"}
              labelname={"அசல் தொகை கூட்டுதல்"}
              name="interest_income"
              value={formData.topup_amount}
              onChange={(e) => handleChange(e, "topup_amount")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அசல் தொகை குறைத்தல்"}
              labelname={"அசல் தொகை குறைத்தல்"}
              name="deduction_amount"
              value={formData.deduction_amount}
              onChange={(e) => handleChange(e, "deduction_amount")}
            ></TextInputForm>
          </Col>
          <Col lg="12" md="12" xs="12" className="py-5 align-self-center">
            <div className="text-center">
              {type === "view" ? (
                <ClickButton
                  label={<>back</>}
                  onClick={() => navigate("/console/interest")}
                ></ClickButton>
              ) : (
                <>
                  {type === "edit" ? (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          disabled={loading} onClick={handleUpdateSubmit}
                        ></ClickButton>
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/interest")}
                        ></ClickButton>
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<> Submit</>}
                          disabled={loading} onClick={handleSubmit}

                        ></ClickButton>
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/interest")}
                        ></ClickButton>
                      </span>
                    </>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>
        {error && (
          <Alert variant="danger" className="error-alert">
            {error}
          </Alert>
        )}
      </Container>
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Body className="text-center">
          <img
            src={require("../../components/sidebar/images/output-onlinegiftools.gif")}
            alt="Success GIF"
          />
          <p>User saved successfully!</p>
        </Modal.Body>
        <Modal.Footer>
          <ClickButton
            variant="secondary"
            label={<> Close</>}
            onClick={() => redirectModal()}
          >
            Close
          </ClickButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserCreation;
